var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H36C39.3137 0 42 2.68629 42 6V36C42 39.3137 39.3137 42 36 42H6C2.68629 42 0 39.3137 0 36V6Z",
    fill: "#E2E8F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1038_9098)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6 14.7004C12.4343 14.7004 12.3 14.8347 12.3 15.0004V17.7004H29.7V15.0004C29.7 14.8347 29.5657 14.7004 29.4 14.7004H12.6ZM10.5 15.0004V18.6004V27.0004C10.5 28.1602 11.4402 29.1004 12.6 29.1004H29.4C30.5598 29.1004 31.5 28.1602 31.5 27.0004V18.6004V15.0004C31.5 13.8406 30.5598 12.9004 29.4 12.9004H12.6C11.4402 12.9004 10.5 13.8406 10.5 15.0004ZM29.7 27.0004V19.5004H12.3V27.0004C12.3 27.1661 12.4343 27.3004 12.6 27.3004H29.4C29.5657 27.3004 29.7 27.1661 29.7 27.0004ZM15 22.2004C14.3373 22.2004 13.8 22.7376 13.8 23.4004C13.8 24.0631 14.3373 24.6004 15 24.6004H17.4C18.0627 24.6004 18.6 24.0631 18.6 23.4004C18.6 22.7376 18.0627 22.2004 17.4 22.2004H15Z",
    fill: "#94A3B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1038_9098"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 10.5,
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.3e6b9dea9d764dc1f9b8ca3b2570a4e2.svg";
export { ForwardRef as ReactComponent };